export default {
  SEARCH_CATALOG_KUSPIT_ADDRESS_QUERY: Symbol.for('SEARCH_CATALOG_KUSPIT_ADDRESS_QUERY'),
  CATALOG_KUSPIT_ADDRESS_REPOSITORY: Symbol.for('CATALOG_KUSPIT_ADDRESS_REPOSITORY'),
  CATALOG_KUSPIT_ADDRESS_STATE_MANAGER: Symbol.for('CATALOG_KUSPIT_ADDRESS_STATE_MANAGER'),
};
